
export function getPhoneLink() {
    const codes = [43, 52, 57, 49, 53, 49, 53, 48, 56, 53, 48, 57, 52, 50];
    const number = String.fromCharCode(...codes);
    return `tel:${number}`;
}